import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './styles.css';

class Item extends Component {
	render() {
		const { active, onClick } = this.props;
		return (
			<div
				className={`bottle-selector-layout-item ${active ? 'selected' : ''}`}
				onClick={onClick}
			>
				{this.props.children}
			</div>
		);
	}
}
Item.propTypes = {
	active: PropTypes.bool,
	onClick: PropTypes.func
};
export default Item;
